/**
 * A page that breaks must not take the whole app with it: the frame stays, the page says what went
 * wrong, and the way to the older screens (the same data) is one press away.
 */
import { Component, type ReactNode } from 'react'

export class Guard extends Component<{ children: ReactNode; name: string }, { error: Error | null }> {
  state = { error: null as Error | null }
  static getDerivedStateFromError(error: Error) {
    return { error }
  }
  componentDidCatch(error: Error) {
    console.error(`[${this.props.name}]`, error)
  }
  componentDidUpdate(prev: { name: string }) {
    // moving to another page clears the problem of the one before
    if (prev.name !== this.props.name && this.state.error) this.setState({ error: null })
  }
  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="flex min-h-full flex-col items-center justify-center px-6 pb-[12vh] pt-10 text-center">
        <h1 className="m-0 font-ws-serif text-[28px] font-normal leading-9 tracking-[-0.01em] text-ws-fg">This page hit a problem</h1>
        <p className="m-0 mt-3 max-w-[460px] text-[13px] leading-5 tracking-normal text-ws-fg-3">Nothing was lost: it is only this screen that could not be drawn. The rest of the app works, and the older screens show the same data.</p>
        <p className="m-0 mt-3 max-w-[560px] break-words font-mono text-[12px] leading-[18px] tracking-normal text-ws-fg-4">{this.state.error.message}</p>
        <div className="mt-6 flex items-center gap-2">
          <button type="button" onClick={() => this.setState({ error: null })} className="flex h-8 items-center rounded-[8px] bg-white px-3 font-medium text-black">
            Try again
          </button>
          <a href="/classic.html" className="flex h-8 items-center rounded-[8px] border border-ws-edge px-3 text-ws-fg-2 transition-colors hover:text-ws-fg">
            Open the older screens
          </a>
        </div>
      </div>
    )
  }
}
